import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class DeletedataService {
  authToken:any;
  headers= new Headers();
  constructor(private http:Http, private authService:AuthenticationService) { 
    this.authService.RetrieveloadToken();
    this.headers.append('Authorization', this.authService.RetrieveloadToken());
  }

  deleteEvent(id,eventlogopath){
    return this.http.delete("/deletes/delete_event/"+id+"/"+eventlogopath,{headers:this.headers})
    .map(res => res.json());
  }

  deleteRoom(id,roomdefaultlogo){
    return this.http.delete("/deletes/delete_room/"+id+"/"+roomdefaultlogo,{headers:this.headers})
    .map(res => res.json());
  }

  deleteUser(id){
    return this.http.delete("/users/delete_user/"+id,{headers:this.headers})
    .map(res => res.json());
  }

  deleteWorkgroup(id){
    return this.http.delete("/deletes/delete_workgroup/"+id,{headers:this.headers})
    .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/deletedata.service.ts